<template>
    <component :is="currentComponent" />
</template>

<script>
import XiHome from '@/components/showcase/home/XiHome'
import KocomHome from '@/components/showcase/home/KocomHome'
import SoldocHome from '@/components/showcase/home/SoldocHome'
import SeoulOneHome from '@/components/showcase/home/SeoulOneHome'
import LynnHome from '@/components/showcase/home/LynnHome'
import Bodyfriend from '@/components/showcase/home/Bodyfriend'
import HonorsvilleHome from '@/components/showcase/home/HonorsvilleHome'
import ChampionscityHome from '@/components/showcase/home/ChampionscityHome'

export default {
    name: 'home',
    components: {
        XiHome,
        KocomHome,
        SoldocHome,
        SeoulOneHome,
        LynnHome,
        Bodyfriend,
        HonorsvilleHome,
        ChampionscityHome
    },
    computed: {
        currentComponent: function() {
            const componentMap = {
                xi: 'XiHome',
                kocom: 'KocomHome',
                soldoc: 'SoldocHome',
                seoulone: 'SeoulOneHome',
                lynn: 'LynnHome',
                bodyfriend: 'Bodyfriend',
                honorsville: 'HonorsvilleHome',
                championscity: 'ChampionscityHome'
            }
            return componentMap[this.$route.params.showcase] || 'XiHome'
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/showcase/Home.vue